import React, { useMemo } from "react"
import { useDocuments, useDocument } from "@/lib/queries"
import { ClinicalReviewsListView } from "@/components/shared/ClinicalReviewsListView"

export function ClinicalReviewsListPage() {
  const { data: groups, isLoading } = useDocuments()

  const docs = useMemo(
    () =>
      groups?.find((g) => g.document_type === "clinical_review")?.documents ??
      [],
    [groups]
  )

  return (
    <ClinicalReviewsListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useDocument}
    />
  )
}
